<template>
  <div>

    <!-- 删除订单 -->
    <el-dialog :title="$t('message.deleteOrder')" :close-on-click-modal="false" :visible.sync="dialogVisible"
      width="400px" center>
      <div class="content">
        <el-input type="textarea" :placeholder="$t('message.deleteOrderRemark')" v-model="deleteData.delete_reason"
          show-word-limit rows="4">
        </el-input>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">
          {{ $t("message.cancel") }}
        </el-button>
        <!-- 删除保存 -->
        <el-button type="primary" @click="deleteOrder">
          {{ $t("message.delete") }}
        </el-button>

      </span>
    </el-dialog>
  </div>
</template>
<script>
export default {
  data() {
    return {
      deleteData: {
        order_sn_set: [],
        delete_reason: "",
      },
      dialogVisible: false,
    };
  },
  methods: {
    // 删除订单
    deleteOrder() {
      this.$confirm('此操作将删除订单, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        center: true
      }).then(() => {
        this.$api.orderApi.deleteOrder(this.deleteData).then(res => {
          this.$message({
            type: 'success',
            message: res.msg
          });
          this.dialogVisible = false;
          this.$parent.refresh();
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消操作'
        });
      });
    },
  },
};
</script>
<style lang='scss' scoped>
.content {
  padding: 20px 20px 0;
  display: flex;


}
</style>